<template>
    <div  v-loading="dataLoading">
        <tab name="13">{{id}} {{activityName}}</tab>
        <el-radio-group v-model="tabList" size="small" class="MB20 MT10">
            <el-radio-button :label="1">总体销售</el-radio-button>
            <el-radio-button v-if="$utils.have('/activity/statistics/summary')" :label="2">票品明细</el-radio-button>
            <el-radio-button v-if="$utils.have('/activity/statistics/summary')" :label="3">购票用户</el-radio-button>
			<el-radio-button v-if="$utils.have('/activity/statistics/viewingUser')" :label="5">观演用户</el-radio-button>
			<el-radio-button v-if="$utils.have('/activity/statistics/newUser')" :label="4">拉新用户</el-radio-button>			
        </el-radio-group>
		
        <ticket-prices-list v-if="tabList == 1" :activityId="id" :activityName.sync="activityName" :haveEditAudit.sync="haveEditAudit" :data="data" :ticketNameData="ticketNameData"></ticket-prices-list>
        <ticket-sale-list v-else-if="tabList == 2" ref="presentRecordsList" :activityId="id" :haveEditAudit.sync="haveEditAudit" :data="data"></ticket-sale-list>
        <ticket-user-list v-else-if="tabList == 3" :activityId="id" :haveEditAudit.sync="haveEditAudit" :data="data"></ticket-user-list>
		<ticket-newuser-list v-else-if="tabList == 4" :activityId="id" :haveEditAudit.sync="haveEditAudit" :data="data"></ticket-newuser-list>
		<ticket-watchuser-list v-else-if="tabList == 5" :activityId="id" :haveEditAudit.sync="haveEditAudit" :data="data"></ticket-watchuser-list>
    </div>
</template>

<script>
import Tab from '../components/tab';
import TicketPricesList from './components/ticket-prices-list'
import TicketSaleList from './components/ticket-sale-list'
import TicketUserList from './components/ticket-user-list.vue'
import TicketNewuserList from './components/ticket-newuser-list.vue'
import TicketWatchuserList from './components/ticket-watchuser-list.vue'
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    components: { Tab,TicketPricesList,TicketSaleList,TicketUserList,TicketNewuserList,TicketWatchuserList},
    data() {
        return {
            redirect: this.$route.query.redirect || '/activityManage/activity/list',
            dataLoading: false,
            data: null,
            activityName: '',
            tabList: 1,
			haveEditAudit: false,
			ticketNameData:[],
			
			
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
		
        //获取数据
        getData() {
            this.dataLoading = true;
            this.$request({
                url: "/activity/statistics/summary",
                params: { id: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                        this.activityName = result.activityName;
						this.ticketNameData = result.sessionList.filter(item => item.name != '整场演出');
                    } else {
                        this.$message.error(msg || "获取信息失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
      

    }

}
</script>

<style lang="scss" scoped>

</style>